@if (visible && product$ | async; as product) {
  <div class="trustedshops-rating container">
    <h3>{{ 'productDetails.trustedshops.title' | cxTranslate }}</h3>
    <app-custom-trustedshops-widget
      [product]="product"
      widgetType="ProductReviewsTrustedShopsContent"
    ></app-custom-trustedshops-widget>
  </div>
}
